import { useState, useEffect } from 'react';

const ContactModal = ({ isOpen, onClose, bookingUrl }) => {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');

  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [isOpen]);

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();
    // If Square booking URL is set, redirect there
    if (bookingUrl && bookingUrl !== 'https://squareup.com/appointments/book/brocode') {
      window.open(bookingUrl, '_blank');
      onClose();
      return;
    }
    setIsSubmitting(true);
    setTimeout(() => {
      setSubmitMessage("You're locked in — we'll be in touch to confirm your appointment.");
      setIsSubmitting(false);
      setFormData({ name: '', email: '', message: '' });
      setTimeout(() => { setSubmitMessage(''); onClose(); }, 2500);
    }, 1000);
  };

  if (!isOpen) return null;
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <button className="modal__close" onClick={onClose} aria-label="Close">
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path d="M1 1l16 16M17 1L1 17" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
          </svg>
        </button>
        <div className="modal__head">
          <p className="modal__eyebrow">Book Your Cut</p>
          <h2 className="modal__title">Let's Get You Right</h2>
        </div>
        {submitMessage ? (
          <div className="modal__success">
            <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
              <circle cx="14" cy="14" r="13" stroke="currentColor" strokeWidth="1.5"/>
              <path d="M8 14l4 4 8-8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            <p>{submitMessage}</p>
          </div>
        ) : (
          <form className="modal__form" onSubmit={handleSubmit}>
            <div className="field">
              <label htmlFor="name">Name</label>
              <input type="text" id="name" name="name" value={formData.name}
                onChange={handleChange} required placeholder="Your name" />
            </div>
            <div className="field">
              <label htmlFor="email">Email</label>
              <input type="email" id="email" name="email" value={formData.email}
                onChange={handleChange} required placeholder="your@email.com" />
            </div>
            <div className="field">
              <label htmlFor="message">Message</label>
              <textarea id="message" name="message" value={formData.message}
                onChange={handleChange} required rows="5"
                placeholder="Tell us what you need — service, preferred barber, best time…" />
            </div>
            <button type="submit" className="modal__submit" disabled={isSubmitting}>
              {isSubmitting ? <span className="modal__spinner" /> : (
                <>Book My Appointment
                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                    <path d="M2 7h10M8 3l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </>
              )}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default ContactModal;